import { IMessage } from 'src/interfaces/message';
/**
 * Adds or updates a message in an array of messages.
 * If the message already exists (by _id), it replaces it; if not, it adds it to the end.
 *
 * @param messages - Current array of messages (can be undefined, null or not an array)
 * @param newMessage - New or updated message
 * @returns Updated array with the added or updated message
 */
export function addOrUpdateMessage(
    messages: IMessage[] | undefined | null,
    newMessage: IMessage
): IMessage[] {
    const messagesArray = Array.isArray(messages) ? messages : [];

    const existingMessageIndex = messagesArray.findIndex(
        (msg) => msg._id === newMessage._id
    );

    if (existingMessageIndex !== -1) {
        const updatedMessages = [...messagesArray];
        updatedMessages[existingMessageIndex] = newMessage;
        return updatedMessages;
    }

    return [...messagesArray, newMessage];
}
